import {
  TeacherPin,
  SortingQuestionPinTeacherSettingsSchema,
  getSortingQuestionAnswerOrderGenerator,
  TeacherPinSchema,
} from '@lessonup/pins-shared';
import { AssignmentPin, AssignmentMeta } from '../classic';

export function assignmentPinToPin(assignmentPin: AssignmentPin, assignmentMeta: AssignmentMeta): TeacherPin {
  const teacherSettings = AssignmentMeta.teacherSettingsForPin(assignmentMeta, assignmentPin.id);

  switch (assignmentPin.type) {
    case 'SORTING_QUESTION': {
      const sortingTeacherSettings = SortingQuestionPinTeacherSettingsSchema.parse(teacherSettings);
      const correctOrder = sortingTeacherSettings.correctOrder;
      const keys = getSortingQuestionAnswerOrderGenerator([]).nKeysStart(correctOrder.length);
      const correctOrderToIndexMap = new Map(
        correctOrder.map((correctOrderId, index) => [correctOrderId, keys[index]])
      );

      return TeacherPinSchema.parse({
        ...assignmentPin,
        teacherSettings,
        settings: {
          ...assignmentPin.settings,
          answers: Object.fromEntries(
            Object.entries(assignmentPin.settings.answers).map(([key, value]) => [
              key,
              {
                ...value,
                correctOrder: correctOrderToIndexMap.get(key),
              },
            ])
          ),
        },
      });
    }
  }

  return TeacherPinSchema.parse({
    ...assignmentPin,
    teacherSettings,
  });
}
